var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('menus',{ref:"menus",on:{"onSelect":_vm.onSelectMenus}}),_c('router-view'),_c('footerBox',{ref:"footBox",attrs:{"hiddenContact":_vm.hiddenContact},on:{"onSelect":_vm.onSelectFooterBox}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }